/* eslint-disable */
import {ListViewProduct} from './ListViewProduct';
export enum TopSellerHighlight {
	Bestseller = 0,
	TopTested = 1,
	BestDiscount = 2,
	
}
/**
* @description Interface for Avensia.Commerce.Web.src.views.ProductPage.CompareProduct
*/
export interface CompareProduct extends ListViewProduct {
	highlight?: TopSellerHighlight;
	attributes: Record<string, string>;
}
